import { render, staticRenderFns } from "./ReplacementContractChange.vue?vue&type=template&id=4a4195a8"
import script from "./ReplacementContractChange.vue?vue&type=script&lang=js"
export * from "./ReplacementContractChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports